<template>
  <ValidationObserver v-slot="{ valid }" slim>
    <a-form>
      <a-card :title="$t('Representatives')">
        <p>
          {{ $t("representatives_subtitle") }}
        </p>
        <p></p>
        <a-row :gutter="16">
          <a-col :span="8">
            <p>{{ $t("First Name") }}</p>
            <ValidationProvider
              :immediate="immediate"
              mode="eager"
              :name="$t('First Name')"
              rules="required"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <a-input
                  :size="$store.state.clientInfo.uiSize"
                  :placeholder="$t('First Name Placeholder')"
                  v-model="firstName"
                />
              </a-form-item>
            </ValidationProvider>
          </a-col>
          <a-col :span="8" v-if="$i18n.locale == 'en'">
            <p>{{ $t("Middle Name(Optional)") }}</p>
            <ValidationProvider
              :immediate="true"
              mode="eager"
              :name="$t('Middle Name(Optional)')"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <a-input
                  ref="txtMiddleName"
                  :size="$store.state.clientInfo.uiSize"
                  :placeholder="$t('Middle Name Placeholder')"
                  v-model="middleName"
                />
              </a-form-item>
            </ValidationProvider>
          </a-col>
          <a-col :span="8">
            <p>{{ $t("Last Name") }}</p>
            <ValidationProvider
              :immediate="immediate"
              mode="eager"
              :name="$t('Last Name')"
              rules="required"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <a-input
                  :size="$store.state.clientInfo.uiSize"
                  :placeholder="$t('Last Name Placeholder')"
                  v-model="lastName"
                />
              </a-form-item>
            </ValidationProvider>
          </a-col>
        </a-row>
        <p></p>
        <a-row :gutter="16">
          <a-col :span="8">
            <p>{{ $t("Title") }}</p>
            <ValidationProvider
              :immediate="immediate"
              mode="eager"
              :name="$t('Title')"
              rules="required"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <a-input
                  :size="$store.state.clientInfo.uiSize"
                  :placeholder="$t('Title Placeholder')"
                  v-model="title"
                />
              </a-form-item>
            </ValidationProvider>
          </a-col>
          <a-col :span="8">
            <p>{{ $t("Email") }}</p>
            <ValidationProvider
              :immediate="immediate"
              mode="eager"
              :name="$t('Email')"
              rules="required|email"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <a-input
                  :size="$store.state.clientInfo.uiSize"
                  :placeholder="$t('Email Placeholder')"
                  v-model="email"
                />
              </a-form-item>
            </ValidationProvider>
          </a-col>
        </a-row>
        <p></p>
        <a-row :gutter="16">
          <a-col :span="12">
            <p>{{ $t("Country") }}</p>
            <ValidationProvider
              :immediate="immediate"
              mode="eager"
              :name="$t('Country')"
              rules="required"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <a-select
                  showSearch
                  allowClear
                  showArrow
                  v-model="country"
                  :size="$store.state.clientInfo.uiSize"
                  :placeholder="$t('Select Country')"
                  :getPopupContainer="() => $root.$el"
                  @change="handleChangeCountry"
                >
                  <a-icon slot="suffixIcon" type="caret-up" theme="filled" />
                  <a-select-option
                    v-for="item in countryList"
                    :key="item[regionLangName]"
                  >
                    {{ item[regionLangName] }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </ValidationProvider>
          </a-col>
          <a-col :span="12">
            <p>{{ $t("State Province") }}</p>
            <ValidationProvider
              :name="$t('State Province')"
              rules="required|stateCheck"
              :immediate="immediate"
              mode="eager"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <a-select
                  showSearch
                  allowClear
                  v-model="state"
                  :placeholder="$t('State Province Placeholder')"
                  :getPopupContainer="() => $root.$el"
                  :disabled="!country"
                >
                  <a-select-option
                    v-for="item in provinceList"
                    :key="item[regionLangName]"
                  >
                    {{ item[regionLangName] }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </ValidationProvider>
          </a-col>
        </a-row>
        <p></p>
        <a-row :gutter="16">
          <a-col :span="8">
            <p>{{ $t("City") }}</p>
            <ValidationProvider
              :name="$t('City')"
              rules="required|cityCheck"
              :immediate="immediate"
              mode="eager"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <a-input
                  :size="$store.state.clientInfo.uiSize"
                  :placeholder="$t('City placeholder')"
                  v-model="city"
                />
              </a-form-item>
            </ValidationProvider>
          </a-col>
          <a-col :span="8">
            <p>{{ $t("Residential Address") }}</p>
            <ValidationProvider
              :name="$t('Residential Address')"
              rules="required"
              :immediate="immediate"
              mode="eager"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <validation-input-google-auto-complete
                  class="input-google-auto-complete"
                  :size="$store.state.clientInfo.uiSize"
                  :placeholder="$t('Residential Address Placeholder')"
                  v-model="autoBusinessAddress"
                  :isValid="slotProps.errors.length === 0"
                  flag="full"
                  :iso2="countryIso2"
                >
                </validation-input-google-auto-complete>
              </a-form-item>
            </ValidationProvider>
          </a-col>
          <a-col :span="8">
            <p>{{ $t("Zip Code") }}</p>
            <ValidationProvider
              :name="$t('Zip Code')"
              rules="required"
              :immediate="immediate"
              mode="eager"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <a-input
                  :size="$store.state.clientInfo.uiSize"
                  :placeholder="$t('Zip Code Placeholder')"
                  v-model="zipcode"
                />
              </a-form-item>
            </ValidationProvider>
          </a-col>
        </a-row>
        <p></p>
        <a-row :gutter="16">
          <a-col :span="8">
            <p>{{ $t("Date of Birth") }}</p>
            <ValidationProvider
              :immediate="immediate"
              :name="$t('Date of Birth')"
              rules="required"
              mode="eager"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <a-date-picker
                  format="YYYY-MM-DD"
                  :size="$store.state.clientInfo.uiSize"
                  :placeholder="$t('Select Birthday')"
                  v-model="birthday"
                  :getCalendarContainer="() => $root.$el"
                />
              </a-form-item>
            </ValidationProvider>
          </a-col>
          <a-col :span="8">
            <p class="custp">{{ $t("Telephone") }}</p>
            <a-form-item
              name="telInputItem"
              ref="telInputItem"
              has-feedback
              :validate-status="resolveState4TelInput()"
            >
              <div slot="help" class="tips-help">
                {{ helpMsg4TelInput }}
              </div>
              <vue-tel-input
                ref="telinput"
                v-if="isFetched"
                v-model="phone"
                inputClasses="ant-input"
                :enabledCountryCode="true"
                :disabledFetchingCountry="true"
                :defaultCountry="iso2"
                :preferredCountries="defaultTelCountry"
                :ignoredCountries="highRiskTelCountries"
                :wrapperClasses="[
                  'vti-wrapper',
                  $store.state.clientInfo.uiSize
                ]"
                :placeholder="$t('Telephone Placeholder')"
                @validate="doValidate($event)"
                @country-changed="countryChanged"
                @focus="isTelInputTouched = true"
              >
              </vue-tel-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <p>{{ $t("Document Number") }}</p>
            <ValidationProvider
              :name="$t('Document Number')"
              rules="required"
              :immediate="immediate"
              mode="eager"
              v-slot="slotProps"
            >
              <a-form-item
                has-feedback
                :validate-status="resolveState(slotProps)"
                :help="slotProps.errors[0]"
              >
                <a-input
                  :size="$store.state.clientInfo.uiSize"
                  :placeholder="$t('Document Number Placeholder')"
                  v-model="passport"
                />
              </a-form-item>
            </ValidationProvider>
          </a-col>
        </a-row>
        <br />
      </a-card>
    </a-form>
    <btm-step-nav
      :passed="valid && checkTelephone"
      :loading="isLoading"
      @submitForm="submitForm"
    ></btm-step-nav>
  </ValidationObserver>
</template>

<script>
import { mapState } from "vuex";
import {
  Card,
  Button,
  Input,
  Row,
  Col,
  Select,
  DatePicker,
  Form,
  Icon,
  Radio
} from "ant-design-vue";
import { withValidation } from "vee-validate";
import Moment from "moment";
import { VueTelInput } from "vue-tel-input";
import BtmStepNav from "@/components/BtmStepNavInstitution";
import InputGoogleAutoComplete from "@/components/InputGoogleAutoComplete";
import {
  getRepresentives,
  submitRepresentives,
  queryKycRegion
} from "@/api/kyc";
import { displayErrors, getCountryList, highRiskTelCountries } from "@/utils";

const PREFIX_ORIGIN = "__origin-";

const ValidationInputGoogleAutoComplete = withValidation(
  InputGoogleAutoComplete
);

export default {
  name: "Representives",
  data() {
    return {
      firstName: "",
      middleName: "",
      lastName: "",
      title: "",
      email: "",
      country: undefined,
      businessAddress: "",
      city: "",
      state: "",
      zipcode: "",
      birthday: null,
      phone: "",
      passport: "",
      dialCode: "",
      iso2: "",
      telephoneValid: -1, // -1 默认状态 0 不通过 1 通过
      helpMsg4TelInput: "",
      immediate: false,
      isFetched: false,
      isTelInputTouched: false,
      state4TelInput: "",
      isLoading: false,
      highRiskTelCountries,
      countryIso2: "",
      countryList: [],
      provinceList: []
    };
  },
  computed: {
    ...mapState("KYC", {
      enableVeriff: "enableVeriff4Institution"
    }),
    ...mapState({
      uiSize: state => state.clientInfo.uiSize,
      appId: state => state.clientInfo.appId
    }),
    regionLangName() {
      return "name_en";
    },
    langName() {
      return this.$i18n.locale === "zh" ? "CHS" : "ENG";
    },
    checkTelephone() {
      return this.telephoneValid === 1;
    },
    defaultTelCountry() {
      if (this.appId === "LGWeb") {
        return ["US", "CN", "HK", "JP", "SG"];
      } else {
        return ["US", "SG", "HK", "JP", "CN"];
      }
    },
    getLowRiskCountryList() {
      return getCountryList();
    },
    autoBusinessAddress: {
      get() {
        return this.businessAddress;
      },
      set(value) {
        if (Array.isArray(value)) {
          const addressComponents = value;
          let street_number = "";
          let route = "";
          let postal_code = "";
          let postal_code_suffix = "";
          let city = "";
          let state = "";
          addressComponents.forEach(item => {
            const componentType = item.types[0];
            if (componentType === "street_number") {
              street_number = item.long_name;
            } else if (componentType === "route") {
              route = item.short_name;
            } else if (componentType === "postal_code") {
              postal_code = item.long_name;
            } else if (componentType === "postal_code_suffix") {
              postal_code_suffix = `-${item.long_name}`;
            } else if (componentType === "locality") {
              city = item.long_name;
            } else if (componentType === "administrative_area_level_1") {
              state = item.short_name;
            }
          });

          this.businessAddress = `${street_number} ${route}`;
          this.zipcode = `${postal_code}${postal_code_suffix}`;
          this.city = city;
          this.state = state;
        } else {
          this.businessAddress = value;
        }
      }
    }
  },
  watch: {
    state4TelInput(value) {
      if (value !== "") {
        this.$nextTick(() => {
          // 这种情况下dom一定存在 硬编码 :(
          this.$refs.telInputItem.$el.querySelector(
            ".ant-form-item-children"
          ).style.display = "inline-block";
        });
      }
    }
  },
  components: {
    [Card.name]: Card,
    [Button.name]: Button,
    [Input.name]: Input,
    [Row.name]: Row,
    [Col.name]: Col,
    [Select.name]: Select,
    [Select.Option.name]: Select.Option,
    [Select.OptGroup.name]: Select.OptGroup,
    [DatePicker.name]: DatePicker,
    [Form.name]: Form,
    [Form.Item.name]: Form.Item,
    [Icon.name]: Icon,
    [Radio.name]: Radio,
    [Radio.Group.name]: Radio.Group,
    VueTelInput,
    BtmStepNav,
    ValidationInputGoogleAutoComplete
  },
  methods: {
    resolveState({ errors, pending, valid }) {
      if (errors[0]) {
        return "error";
      }
      if (pending) {
        return "validating";
      }
      if (valid) {
        return "success";
      }
      return "";
    },
    resolveState4TelInput() {
      if (!this.isTelInputTouched) {
        this.helpMsg4TelInput = "";
        this.state4TelInput = "";
        return "";
      } else if (this.telephoneValid == 1) {
        this.helpMsg4TelInput = "";
        this.state4TelInput = "success";
        return "success";
      } else if (this.telephoneValid == 0) {
        this.helpMsg4TelInput = this.$t("Incorrect phone format");
        this.state4TelInput = "error";
        return "error";
      } else {
        this.helpMsg4TelInput = "";
        this.state4TelInput = "";
        return "";
      }
    },
    doValidate(e) {
      this.telephoneValid = e.valid ? 1 : 0;
    },
    countryChanged(e) {
      this.iso2 = e.iso2;
      this.dialCode = e.dialCode;
    },
    async submitRepresentives() {
      let phone = this.phone.replace(/\s*/g, "");
      const formData = new FormData();
      formData.append("first_name", this.firstName);
      formData.append("middle_name", this.middleName);
      formData.append("last_name", this.lastName);
      formData.append("title", this.title);
      formData.append("email", this.email);
      formData.append("country", this.country);
      formData.append("residential_address", this.businessAddress);
      formData.append("city", this.city);
      formData.append("state", this.state);
      formData.append("zipcode", this.zipcode);
      formData.append("birthdate", this.birthday.format("YYYY-MM-DD"));
      formData.append("phone_country_code", this.dialCode);
      formData.append("phone_country_code_short", this.iso2);
      formData.append("phone_number", phone);
      formData.append("ssn", this.passport);

      await submitRepresentives(formData);
    },
    async fetchRepresentives() {
      const data = await getRepresentives();
      // let data = {};
      this.firstName = data.first_name || "";
      this.middleName = data.middle_name || "";
      this.lastName = data.last_name || "";
      this.title = data.title || "";
      this.email = data.email || "";
      this.country = data.country || undefined;
      this.businessAddress = data.residential_address || "";
      this.city = data.city || "";
      this.state = data.state || "";
      this.zipcode = data.zipcode || "";
      this.birthday = data.birthdate
        ? Moment(data.birthdate, "YYYY-MM-DD")
        : null;
      this.phone = data.phone_number || "";
      this.dialCode = data.phone_country_code || "1";
      this.iso2 = data.phone_country_code_short || "US";
      this.passport = data.ssn || "";

      this.immediate = true;
    },
    async submitForm(callBack) {
      try {
        this.isLoading = true;
        await this.submitRepresentives();
        callBack(true);
        this.isLoading = false;
      } catch (err) {
        callBack(false);
        displayErrors(err);
        this.isLoading = false;
      }
    },
    async fetchData() {
      try {
        await this.fetchRepresentives();
      } catch (err) {
        displayErrors(err);
      } finally {
        this.isFetched = true;
        this.initRegionData();
      }
    },
    async fetchRegions(parent_id = 0, prop = "countryList") {
      try {
        const result = await queryKycRegion({
          parent_id,
          allowed_user_type: "entity"
        });
        if (!result.errors) {
          this[prop] = result.data;
        } else {
          displayErrors(result);
        }
      } catch (err) {
        displayErrors(err);
      }
    },
    async initRegionData() {
      await this.fetchRegions();
      const existCountry = this.countryList.find(
        i => i[this.regionLangName] === this.country
      );
      this.countryIso2 = existCountry?.iso2_code ?? "";

      if (existCountry) {
        await this.fetchRegions(existCountry.id, "provinceList");
      }
    },
    async handleChangeCountry(name) {
      const existCountry = this.countryList.find(
        i => i[this.regionLangName] === name
      );
      this.countryIso2 = existCountry?.iso2_code ?? "";

      if (existCountry) {
        this.province = undefined;
        this.city = "";
        await this.fetchRegions(existCountry.id, "provinceList");
      } else {
        this.province = undefined;
        this.city = "";
      }
    }
  },
  created() {
    this.dialCode = "1";
    this.iso2 = "US";
    this.fetchData();
  },
  activated() {}
};
</script>

<style lang="scss" scoped>
.vti-wrapper {
  &.vue-tel-input:focus-within {
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(191, 168, 124, 0.6);
    border-color: #b39058;
  }
  &.large {
    height: 2.5rem;
    margin-top: 0;
  }
  &.small {
    height: 1.5rem;
    margin-top: 0.5rem;
  }
}
.tips-help {
  margin-top: 0.3rem;
}
.custp {
  margin-bottom: 1em;
}
</style>
